module.exports = __webpack_public_path__ + "img/module-profile.0636aaf4.svg";